import { render } from "./MediaItem.vue?vue&type=template&id=123e4277"
import script from "./MediaItem.vue?vue&type=script&lang=js"
export * from "./MediaItem.vue?vue&type=script&lang=js"

import "./MediaItem.vue?vue&type=style&index=0&id=123e4277&lang=scss"

import exportComponent from "c:\\Clients\\VoterFly\\application\\VoterFly\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__